import { render, staticRenderFns } from "./flammable-gas-cas.vue?vue&type=template&id=2e0bcce4"
import script from "./flammable-gas-cas.vue?vue&type=script&lang=js"
export * from "./flammable-gas-cas.vue?vue&type=script&lang=js"
import style0 from "./flammable-gas-cas.vue?vue&type=style&index=0&id=2e0bcce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports